import React, { Component } from 'react';
// import '../App.css';
import "./style/style.scss"
import { Button, Checkbox, Col, Form, Input, Radio, Select, message } from 'antd'
import { downloadLink, IcaLoginDto, initState, IState } from "./State";
import LoginBackg from "./img/loginbackg.jpg"
import BackTop from "./img/bcTop.png"
import BackBottom from "./img/bottom.png"
import swap from "./img/swap.svg"
import user from "./img/Frame (2).svg"
import lock from "./img/Frame (3).svg"
import ca from "./img/ca.svg"
import pin from "./img/pin.svg"
import { styled } from 'styled-components';
import { Service } from './Service';
import HunanCA from "../framework/utils/HuNanCALib/api";
import BeijingCA from "../framework/utils/BeijingCALib/Login/api"
import BeijingCAAsync from "../framework/utils/BeijingCALib/Login/xtxasyn"
import CodeBtn from './codeBtn/CodeBtn';
import LoadingBtn from './LoadingBtn/LoadingBtn';

interface IProps {
  form: any;
}

const CAType = [
  // { type: "湖南CA" },
  { type: "湖南省公共资源CA共享平台" },
];

const items = [
  { id: "T", name: "招标人（采购人）" },
  { id: "B", name: "投标人（供应商）" },
  { id: "A", name: "代理机构" }
];

const regNumber = /\d+/; //验证0-9的任意数字最少出现1次。
const regString = /[a-zA-Z]+/; //验证大小写26个字母任意字母最少出现1次。
const regSpecial = /[!@#$%^&*()_+]+/; // 验证特殊字符至少出现1次

const { Option } = Select
const InputGroup = Input.Group;


class App extends Component<IProps, IState> {
  state = initState;
  service = new Service();

  componentDidMount() {
    this.init();
    // this.setRegisterInfo()
  }

  async init() {
    this.setAccount();
  }

  setAccount = () => {
    const { setFieldsValue } = this.props.form;
    const localAccount = localStorage.getItem("account");
    if (localAccount) {
      const account = JSON.parse(localAccount);
      setFieldsValue(account);
    }
  };

  handleKeyDown = (e: any) => {
    if (e.keyCode === 13) {
      this.handleLogin(e);
    }
  };

  loginMessage = () => {
    const { loginMessage } = this.state;
    return <p style={{ color: "#ED1717" }}>{loginMessage}</p>;
  };

  /**记住密码公告 */
  rememberThePassword = (values: any) => {
    if (values.checked) {
      localStorage.setItem("account", JSON.stringify(values));
    } else {
      values.password = "";
      localStorage.setItem("account", JSON.stringify(values));
    }
  };

  handleLogin = (e: any) => {
    this.props.form.validateFields(async (err: any, values: any) => {
      if (!err) {
        this.setState({
          btnLoading: true
        });
        const data = await this.service.login(values).finally(() => {
          this.setState({
            btnLoading: false
          });
        });
        if (data.isOk === true) {
          const { access_token, refresh_token, token_type } = data.loginData
          this.rememberThePassword(values);
          window.open(`https://ebs.hbncp.com.cn/out/login?access_token=${access_token}&refresh_token=${refresh_token}&token_type=${token_type}`, '_self')
          return;
        } else {
          this.setState({
            messageVisible: true,
            loginMessage: data.msg
          });
          message.error(data.msg);
        }
      } else {
        message.warning("请按照正确格式填写信息！");
      }
    });


  };

  /**提交事件 */
  handleSubmit = async () => {
    const { validateFields } = this.props.form;
    validateFields((err: any, values: any) => {
      console.log(values);
      values.proMainClass = values.proMainClass.toString();
      if (!err) {
        if (!this.state.checkAgreement) {
          message.warn("请先勾选用户协议!");
          return;
        }
        this.service.register(values).then(res => {
          if (res === true) {
            message.success(`注册成功！`);
            this.handle2Login(values.phone, values.password);
          }
        }).catch((error: any) => {
          // 错误已经在 formatData 中通过 message.error 显示了
          // 这里只需要捕获错误，防止未捕获的 Promise 错误
          console.error("注册失败:", error);
        });

      } else {
      }
    });
  };

  /**登录操作 */
  handle2Login = async (username: string, password: string) => {
    const data = await this.service.login({ username, password });
    if (data.isOk === true) {
      const { access_token, refresh_token, token_type } = data.loginData
      window.open(`https://ebs.hbncp.com.cn/out/login?access_token=${access_token}&refresh_token=${refresh_token}&token_type=${token_type}`, '_self')
      return;
    } else {

    }
  };


  /**检测ca 并登录*/
  checkCABeforeLogin = () => {
    const { validateFields } = this.props.form;
    validateFields(async (err: any, values: any) => {
      if (!err) {
        switch (this.state.caWay) {
          // case 0:
          //   this.loginByHuNanCA(values);
          //   return;
          case 0:
            this.loginByBeijingCA(values);
        }
      } else {
      }
    });
  };

  loginByHuNanCA = async (values: any) => {
    // 生成随机6位数字符串作为待签原文
    const randomStr = Math.random()
      .toString(36)
      .substr(2, 6);
    let caInfo = await HunanCA.getCALoginInfo(randomStr, values.pin);
    if (caInfo.code !== 0) {
      message.warn(caInfo.msg);
      this.setState({
        CAState: 2
      });
      return;
    }

    const dto: any = {
      ...((caInfo.data as unknown) as object),
      grant_type: "ca",
      scope: "server",
      data: randomStr
    };

    this.executeCALogin(dto);
  };

  loginByBeijingCA = async (values: any) => {
    // 北京ca
    // 初始化北京ca 建立ws连接
    BeijingCAAsync.initXtxAsyn()
    BeijingCAAsync.initXtxAppComObject()

    /** 获取certId */
    const certInfo: any = await BeijingCA.getUserList()
    if (certInfo.code !== 0) {
      message.warn(certInfo.msg);
      this.setState({
        CAState: 2
      })
      return;
    }

    const certId = certInfo.data

    /**校验pin码 */
    const pinInfo = await BeijingCA.test_SOF_Login(certId, values.pin)
    if (pinInfo.code !== 0) {
      message.warn(pinInfo.msg);
      return;
    }
    const signData = await BeijingCA.randomSignData(certId)
    const userCert = await BeijingCA.getUserCert(certId)

    const dto = {
      ...signData.data,
      secret: userCert.data,
      key: certId.split("/")[1],
      grant_type: "ca",
      scope: "server"
    };
    this.executeCALogin(dto)
  }

  executeCALogin = async (dto: IcaLoginDto) => {
    const data = await this.service.caLogin(dto);
    if (data.isOk === true) {
      const { access_token, refresh_token, token_type } = data.loginData
      window.open(`https://ebs.hbncp.com.cn/out/login?access_token=${access_token}&refresh_token=${refresh_token}&token_type=${token_type}`, '_self')
      return;
    } else {
      message.error(data.msg);
    }
  };

  // 登录方式切换
  loginWayToggle(index: number) {
    this.setState({
      currentLoginWay: index
    });
    if (index === 1) {
      this.setState({
        caWay: 0
      });
    }
  }

  /* 切换ca登录方式 */
  handleSelectChange = (value: number) => {
    console.log(value);
    this.setState({
      caWay: value
    });
  };

  tabSwitch(index: number) {
    this.setState({
      currentTab: index,
      caWay: 0
    });
    if (index === 2) {
      this.setState({
        currentLoginWay: -1
      });
    } else {
      this.setState({
        currentLoginWay: 1
      });
    }
    this.props.form.setFieldsValue({
      password: ""
    });
  }

  /**获取验证码 */
  beforeCheck = () => {
    const { validateFields } = this.props.form;
    let ok = false;
    validateFields(["phone"], (err: any, value: any) => {
      if (!err) {
        ok = true;
      }
    });
    return ok;
  };

  /**获取验证码 */
  getCode = async () => {
    const { getFieldValue } = this.props.form;
    const phone = getFieldValue("phone");
    const dto = {
      phone,
      smsType: "1"
    };
    const res = await this.service.getCode(dto);
    return res;
  };



  /**协议勾选变化 */
  onCheckChange = (e: { target: { checked: any } }) => {
    this.setState({
      checkAgreement: e.target.checked
    });
  };

  checkPsd = (rule: any, value: any, callback: { (arg0: Error): void; (): void }) => {
    let password2 = this.props.form.getFieldValue("retryPassword");
    if (!regNumber.test(value) ||
      !regString.test(value) ||
      !regSpecial.test(value) ||
      value?.length < 6) {
      callback(new Error("密码必须包含数字、字母和特殊符号，且至少6位"));
      return;
    } else if (password2 && password2 !== value) {
      callback(new Error("两次密码输入不一致"));
    } else {
      callback();
    }
  };

  checkPsd2 = (rule: any, value: any, callback: { (arg0: Error): void; (): void }) => {
    let password2 = this.props.form.getFieldValue("password");
    if (!regNumber.test(value) ||
      !regString.test(value) ||
      !regSpecial.test(value) ||
      value?.length < 6) {
      callback(new Error("密码必须包含数字、字母和特殊符号，且至少6位"));
      return;
    } else if (password2 && password2 !== value) {
      callback(new Error("两次密码输入不一致"));
    } else {
      callback();
    }
  };

  public render() {
    const { getFieldDecorator } = this.props.form;
    const { currentTab, currentLoginWay, CAState, btnLoading } = this.state;

    return (
      <div className="eLogin">
        <img className="bgimg" src={LoginBackg} alt='' />
        <div
          style={{ marginBottom: "40px" }}
          className="wrapper"
        >
          <div
            style={currentTab === 2 ? { padding: 20 } : undefined}
            className="box"
          >
            <img className="bcTop" src={BackTop} alt="bcTop" />
            <img className="bcBottom" src={BackBottom} alt="bcBottom" />
            <div className="loginbox">
              <ul
                style={{
                  marginBottom: "40px"
                }}
                className="logintab"
              >
                <li
                  className={currentTab === 1 ? "active" : ""}
                  onClick={() => {
                    this.tabSwitch(1);
                  }}
                >
                  后台登录
                </li>
                <li
                  onClick={() => {
                    this.tabSwitch(2);
                  }}
                  className={currentTab === 2 ? "active" : ""}
                >
                  用户注册
                </li>
              </ul>

              {/* 登陆表单 账号登录*/}
              {currentLoginWay === 1 && (
                <Form className="loginform">
                  <UserName>
                    {getFieldDecorator("username", {
                      initialValue: "",
                      rules: [{ required: true, message: "请输入用户名" }]
                    })(
                      <Input
                        className="InputUserName"
                        size="large"
                        addonBefore={<img src={user} alt="" />}
                        onKeyDown={this.handleKeyDown}
                        placeholder="请输入账号"
                      />
                    )}
                  </UserName>

                  <PassWord>
                    {getFieldDecorator("password", {
                      initialValue: "",
                      rules: [{ required: true, message: "请输入密码" }]
                    })(
                      <Input.Password
                        key={1}
                        className="InputPassword"
                        size="large"
                        addonBefore={<img src={lock} alt='' />}
                        type="password"
                        onKeyDown={this.handleKeyDown}
                        placeholder="请输入密码"
                      />
                    )}
                  </PassWord>

                  {/* 错误提示 */}
                  {this.loginMessage()}
                  <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}>
                    <Remember>
                      {getFieldDecorator("checked", {
                        initialValue: false,
                        rules: [{ required: false }]
                      })(<Checkbox>记住账号</Checkbox>)}
                    </Remember>
                    <div style={{ zIndex: 999, color: '#555' }} className="forget">
                      {/* <Link
                            to={{
                              pathname: "/out/forget",
                              search: "?place=cz" // 可选参数
                            }}
                          >
                            忘记密码
                          </Link> */}
                      <a style={{ color: '#555' }} href="https://ebs.hbncp.com.cn/out/forget">忘记密码</a>
                    </div>
                  </div>
                  <Button
                    style={{
                      background: "#3D559B",
                      marginTop: "25px"
                    }}
                    type="primary"
                    size="large"
                    block={true}
                    onClick={this.handleLogin}
                    loading={btnLoading}
                  >
                    登录
                  </Button>
                </Form>
              )}
              {/* 登陆表单 CA登录*/}
              {currentLoginWay === 2 && (
                <Form className="loginform ca">
                  <CAInput label="请选择使用的CA" className="caWay">
                    {getFieldDecorator("type", {
                      rules: [{ required: true, message: "请选择使用的CA" }],
                      initialValue: CAType[0].type
                    })(
                      <Select {...{ size: 'large', onChange: this.handleSelectChange }}>
                        {CAType.map((item, index) => <Option key={index} value={index}>{item.type}</Option>
                        )}
                      </Select>
                    )}
                  </CAInput >
                  <PinInput label="请填写PIN码" className="pinInput">
                    {getFieldDecorator("pin", {
                      initialValue: "",
                      rules: [{ required: true, message: "请填写PIN码" }]
                    })(<Input.Password size="large" onKeyDown={this.handleKeyDown} placeholder="请填写PIN码" />)}
                  </PinInput>
                  {CAState === 2 && (
                    <div className="ukey-fail">
                      {/* <Icon type="info-circle" theme="filled" /> */}
                      <p>未检测到您的U-Key，请重新插入</p>
                    </div>
                  )}

                  {
                    <a href={downloadLink[this.state.caWay].link} style={{ position: "relative" }}>
                      {downloadLink[this.state.caWay].title}
                    </a>
                  }
                  <Button
                    style={{
                      background: "#3D559B"
                    }}
                    type="primary"
                    size="large"
                    block={true}
                    onClick={this.checkCABeforeLogin}
                  >
                    检测CA并登录
                  </Button>
                </Form>
              )}
              {/* 登录方式 */}
              {currentTab === 1 && (
                <>
                  <ul className="loginway-toggle">
                    <li style={{ alignItems: 'flex-start' }}>
                      {/* <Icon style={{ marginRight: "5px" }} type="swap" /> */}
                      <img src={swap} alt="" />
                      切换登录方式:
                    </li>
                    <li onClick={() => this.loginWayToggle(1)} className="way by-account">
                      账号登录
                    </li>
                    <li onClick={() => this.loginWayToggle(2)} className="way by-ca">
                      CA锁登陆
                    </li>
                  </ul>
                </>
              )}
              {/* 注册表单 */}
              {currentTab === 2 && (
                <Form className="registerform">
                  {/* <Forms.Inputs.MobilephoneInput
                        label="手机号"
                        getFD={getFieldDecorator}
                        fieldName="phone"
                        isRequired={true}
                      /> */}
                  <Form.Item label="手机号" className="phone">
                    {getFieldDecorator("phone", {
                      initialValue: "",
                      rules: [
                        { required: true, message: "请输入手机号" },
                        { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号格式" }
                      ]
                    })(
                      <Input
                        className="phone"
                        onKeyDown={this.handleKeyDown}
                        placeholder="请输入手机号"
                      />
                    )}
                  </Form.Item>
                  <Form.Item label="密码" className="password">
                    {getFieldDecorator("password", {
                      initialValue: "",
                      rules: [
                        { required: true, message: "请输入密码" },
                        { validator: this.checkPsd }
                      ]
                    })(
                      <Input.Password
                        className="password"
                        onKeyDown={this.handleKeyDown}
                        placeholder="请输入密码"
                      />
                    )}
                  </Form.Item>
                  <Form.Item label="确认密码" className="confirmPassword">
                    {getFieldDecorator("retryPassword", {
                      initialValue: "",
                      rules: [
                        { required: true, message: "请输入确认密码" },
                        { validator: this.checkPsd2 }
                      ]
                    })(
                      <Input.Password
                        className="retryPassword"
                        onKeyDown={this.handleKeyDown}
                        placeholder="请输入确认密码"
                      />
                    )}
                  </Form.Item>
                  <div className="info">
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Form.Item label="姓名" className="name">
                        {getFieldDecorator("name", {
                          initialValue: "",
                          rules: [{ required: true, message: "请输入姓名" }]
                        })(
                          <Input
                            className="name"
                            onKeyDown={this.handleKeyDown}
                            placeholder="请输入姓名"
                          />
                        )}
                      </Form.Item>
                      <Form.Item label="性别" className="sex">
                        {getFieldDecorator("sex", {
                          initialValue: "",
                          rules: [{ required: true, message: "请选择性别" }]
                        })(
                          <Radio.Group>
                            <Radio.Button value="1">男</Radio.Button>
                            <Radio.Button value="2">女</Radio.Button>
                          </Radio.Group>
                        )}
                      </Form.Item>
                    </div>

                    <Form.Item label="所属类型" className="registerHb">
                      {getFieldDecorator("proMainClass", {
                        rules: [{ required: true, message: "请选择公司所属类型" }],
                      })(
                        <Select mode="multiple" {...({} as any)}>
                          {
                            items.map(item => {
                              return <Option key={item.id} value={item.id}>{item.name}</Option>
                            })
                          }
                        </Select>
                      )}
                    </Form.Item>
                    <Form.Item label="验证码" className="verifyCode">
                      <InputGroup compact>
                        <Col span={12}>
                          {getFieldDecorator("verifyCode", {
                            initialValue: "",
                            rules: [{ required: true, message: "请输入验证码" }]
                          })(
                            <Input
                              style={{ height: "32px" }}
                              placeholder="请输入验证码"
                            />
                          )}
                        </Col>
                        <Col style={{ textAlign: "right" }} span={12}>
                          <CodeBtn beforeCheck={this.beforeCheck} getCode={this.getCode} />
                        </Col>
                      </InputGroup>
                    </Form.Item>
                  </div>

                  {/* <Forms.Inputs.PasswordInput
                        label="密码"
                        key={2}
                        getFD={getFieldDecorator}
                        fieldName="password"
                        isRequired={true}
                        validator={this.checkPsd}
                      />
                      <Forms.Inputs.PasswordInput
                        label="确认密码"
                        getFD={getFieldDecorator}
                        fieldName="retryPassword"
                        isRequired={true}
                        validator={this.checkPsd2}
                      />
                      <div className="info">
                        <Forms.Inputs.TextInput
                          style={{ width: "192px" }}
                          label="姓名"
                          getFD={getFieldDecorator}
                          fieldName="name"
                          isRequired={true}
                        />
                        <Forms.Inputs.RadioInput
                          label="性别"
                          getFD={getFieldDecorator}
                          fieldName="sex"
                          rows={[{ id: "1", name: "男" }, { id: "2", name: "女" }]}
                          isRequired={true}
                        />
                      </div>
                      {
                        this.state.isHbWeb ?
                            <Form.Item label="所属类型" className="registerHb">
                              {getFieldDecorator("proMainClass", {
                                rules: [{required: true, message: "请选择公司所属类型"}],
                              })(
                                  <Select size="large" onChange={() => this.registerHbChange()}
                                          placeholder="请选择公司所属类型">
                                    {
                                      items.map((item, index) => {
                                            return <Option value={item.id} key={item.name}>{item.name}</Option>
                                          }
                                      )
                                    }
                                  </Select>
                              )}
                            </Form.Item>
                            :
                            <Forms.Inputs.ComboBoxInput
                                label="所属类型"
                                placeholder="请选择公司所属类型"
                                getFD={getFieldDecorator}
                                fieldName="proMainClass"
                                items={items}
                                canMulSelect={true}
                                isRequired={true}
                                allowClear={false}
                            />
                      }
                      <Forms.Inputs.PhoneInput
                        label="验证码"
                        placeholder="验证码"
                        sFD={setFieldsValue}
                        getFD={getFieldDecorator}
                        fieldName="verifyCode"
                        isRequired={true}
                        rightEle={<CodeBtn beforeCheck={this.beforeCheck} getCode={this.getCode} />}
                      /> */}
                  <LoadingBtn
                    style={{
                      background: "#3D559B",
                      marginBottom: "12px",
                      marginTop: "8px"
                    }}
                    text="注册"
                    onClick={this.handleSubmit}
                    type="primary"
                    block
                    size="large"
                  />
                  <p style={{ position: "relative" }}>
                    <Checkbox onChange={this.onCheckChange}>
                      {`确认已阅读一毂清风`}
                      <a target="_blank" rel="noreferrer" href="https://www.hbncp.com.cn/#/about/3">
                        注册协议
                      </a>
                      及
                      <a target="_blank" rel="noreferrer" href="https://www.hbncp.com.cn/#/about/2">
                        隐私策略
                      </a>
                    </Checkbox>
                  </p>
                </Form>
              )}
            </div>
          </div>
          {
            <div className="bottominfo">
              <div className="bottomtop">
                <span>服务热线：400-112-9919</span>
                <span className="line">|</span>
                <span>技术中心：武汉市洪山区青菱大道648号东湖高新德成科创中心1-302</span>
                <span className="line">|</span>
                <span>运营中心：黄冈市黄州区东门路39号</span>
              </div>
              <div className="bottomdown">
                <span>Copyright © 2020</span>
                <span className="line">|</span>
                <span>www.hbncp.com.cn</span>
                <span className="line">|</span>
                <span>鄂ICP备16010688号</span>
                <span className="line">|</span>
                <span>鄂公网安备 42011102003672号</span>
              </div>
            </div>
          }
        </div>
      </div>
    )
  }
}

// function App() {
//   return (
//     <div className="App">
//       <header className="App-header">
//         <p>
//           Edit <code>src/App.tsx</code> and save to reload.
//         </p>
//       </header>
//     </div>
//   );
// }

const AppForm = Form.create<IProps>()(App);
export default AppForm;

const Remember = styled(Form.Item)`
  margin-bottom: 0;
`

const UserName = styled(Form.Item)`
  margin-bottom: 32px;

  .ant-input-group-addon {
    border-radius: 4px 0px 0px 4px;
    background: rgba(120, 151, 242, 0.16);
    img {
      vertical-align: middle;
    }
  }
  
`
const PassWord = styled(Form.Item)`
  margin-bottom: 0;
  .ant-input-group-addon {
    border-radius: 4px 0px 0px 4px;
    background: rgba(120, 151, 242, 0.16);
    img {
      vertical-align: middle;
    }
  }
  
`

const CAInput = styled(Form.Item)`
.ant-select-selection__rendered .ant-select-selection-selected-value::before {
  content: url(${ca});
  position: relative;
  top: 3px;
  margin-right: 7px;
}
.ant-select-selection-selected-value {
  color: #777777;
}
`

const PinInput = styled(Form.Item)`
.ant-form-item-control .ant-form-item-children::before {
  content: url(${pin});
  position: absolute;
  z-index: 9999999;
  top: -5px;
  left: 10px;
}
.ant-input-lg {
  padding-left: 37px;
  color: #777777;
}
`
